import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "m-desktopControls__topRow" }
const _hoisted_3 = { class: "m-desktopControls__actionButtons" }
const _hoisted_4 = { class: "m-desktopControls__filterContainer" }
const _hoisted_5 = {
  key: 0,
  class: "m-desktopControls__zoom"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionButton = _resolveComponent("ActionButton")!
  const _component_price_level_filter = _resolveComponent("price-level-filter")!
  const _component_stepper_component = _resolveComponent("stepper-component")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "m-desktopControls__container",
    "data-js": "seatmap-controls",
    "data-qa": _ctx.PerformanceQASelectors.SEATMAP_BUTTONS
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.seatmapStore.priceLevelFilter.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([{'-opened' : _ctx.controlState.isFilterOpen, '-active': _ctx.isPricelevelSelected}, "m-desktopControls__filterButton"])
            }, [
              _createVNode(_component_ActionButton, {
                label: {key: _ctx.Translation.Seatmap_action_filter},
                "icon-name": _ctx.controlState.isFilterOpen ? _ctx.IconName.Close : _ctx.IconName.SmallFilter,
                onClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.controlState.switchFilterDialogDisplayTo(!_ctx.controlState.isFilterOpen)))
              }, null, 8, ["label", "icon-name"])
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.promotionStore.availablePromotions.length > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass([{ '-active': _ctx.promotionStore.active }, "m-desktopControls__promoButton"])
            }, [
              _createVNode(_component_ActionButton, {
                label: {key: _ctx.Translation.Seatmap_action_promo},
                "icon-name": _ctx.IconName.Percentage,
                onClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleSidebarPromotionPanel()))
              }, null, 8, ["label", "icon-name"])
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.controlState.isFilterOpen)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.controlState.switchFilterDialogDisplayTo(false))),
                class: "m-desktopControls__filterBackdrop"
              }),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_price_level_filter, { data: _ctx.data }, null, 8, ["data"])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_stepper_component, {
              state: _ctx.seatmapStore.zoom,
              "show-amount": false,
              onStateChange: _ctx.zoomLevelChange
            }, null, 8, ["state", "onStateChange"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      "data-js": "seatmap-back-action",
      style: _normalizeStyle({
                    display: _ctx.controlState.displayExitLayerButton ? '' : 'none',
                    top: _ctx.isMobile ? '15px' : '60px',
                 }),
      class: "m-desktopControls__backButton"
    }, [
      _createVNode(_component_ActionButton, {
        "icon-name": _ctx.IconName.Arrow,
        label: _ctx.exitLevelLabel,
        onClicked: _ctx.layerExit
      }, null, 8, ["icon-name", "label", "onClicked"])
    ], 4)
  ], 8, _hoisted_1)), [
    [_vShow, _ctx.seatmapStore.isReady && !_ctx.seatmapStore.hasGenericError]
  ])
}